const state = {
  units: [{ name: 'KG' }, { name: 'G' }, { name: 'Carat' }],
  paginationcount: [{ name: '5' }, { name: '10' }, { name: '25' }, { name: '50' }]
};

export default {
  namespaced: true,
  state,
  actions: {
    fetchUnits({ commit }, payload) {},
    fetchPaginationCount({ commit }, payload) {}
  }
};
